import { Grid, TableCell, Box } from "@mui/material";
import { styled } from "@mui/system";
import { CustomButton } from "../../common/components/functional/customButton/CustomButton";

export const VerticalAlignGrid = styled(Grid)(() => ({
  marginBottom: "10px",
  alignItems: "center",
}));

export const TableCellBorderless = styled(TableCell)(() => ({
  border: "none",
  padding: "4px",
}));

export const InvoiceContainer = styled(Box)(() => ({
  overflow: "scroll",
  height: "84vh",
  scrollbarWidth: "none",
  paddingBottom: "20px",
}));

export const InvoicePreviewItemGrid = styled(Grid)(() => ({
  padding: "12px",
}));

export const MarginBox = styled(Box)(() => ({
  margin: "10px 0px",
}));

export const BottomSpaceForInvoiceActionBanner = styled(Box)(() => ({
  height: "50px",
}));

export const InvoiceAttachmentsButton = styled(CustomButton)(() => ({
  color: "rgba(0,0,0,0.52)",
  height: "35px",
  borderRadius: "20px",
  padding: "6px 16px",
}));
